import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { useTheme } from '../Flowbite/ThemeContext';
import { useAccordionContext } from './AccordionPanelContext';
export const AccordionContent = ({ children, ...props }) => {
    const { theme: { accordion: { content }, }, } = useTheme();
    const { isOpen } = useAccordionContext();
    const baseStyle = classNames('first:rounded-t-lg', content.base);
    return isOpen ? (_jsx("div", { ...props, className: baseStyle, children: children })) : null;
};
